import React from "react";
import PropTypes from "prop-types";

const ArrowIcon = ({
  onClick,
  size = 24,
  isExpanded = false,
  "data-testid": testId,
}) => (
  <svg
    onClick={onClick}
    width={size}
    height={size}
    viewBox="0 0 24 24"
    style={{
      cursor: "pointer",
      transition: "transform 0.2s",
      transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
      display: "inline-block",
    }}
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    data-testid={testId}
  >
    <polyline points="6 9 12 15 18 9" />
  </svg>
);

ArrowIcon.propTypes = {
  onClick: PropTypes.func,
  size: PropTypes.number,
  isExpanded: PropTypes.bool,
  "data-testid": PropTypes.string,
};

ArrowIcon.defaultProps = {
  onClick: undefined,
  size: 24,
  isExpanded: false,
  "data-testid": undefined,
};

export default ArrowIcon;
